module.exports = __webpack_public_path__ + "static/media/pga.87f4631c.svg";